
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  font-family:var(--ff-dmsans);
}

.profile-hero{
  display:grid;
  grid-template-rows:1fr var(--space-s-4xl) auto;
}

@media screen and (min-width: 1050px){

.profile-hero{
    grid-template-rows:minmax(3rem, 1fr) auto auto
}
  }

div[cloned-slot-name='background-image']{
  height:100%;
}

div[cloned-slot-name='background-image'] picture img{
    display:flex;
    height:100%;
    width:100%;
    object-fit:cover;
    aspect-ratio:3 / 1;
  }

.background-image{
  grid-area:1 / 1 / 3 / 1;
}

se-container{
  width:100%;
  display:flex;
}

.profile-card{
  grid-area:2 / 1 / 4 / 1;
  z-index:1;
}

@media screen and (min-width: 1050px){

.profile-card{
    width:-moz-fit-content;
    width:fit-content
}
  }

.profile-card .card-wrapper{
    background-color:var(--brand-primary-2);
    padding:3rem 1rem 1rem 1rem;
    color:white;
    width:100%;
  }

@media screen and (min-width: 1050px){

.profile-card .card-wrapper{
      padding:3rem;
      width:max-content;
      max-width:500px
  }
    }

@media screen and (min-width: 1600px){

.profile-card .card-wrapper{
      max-width:530px
  }
    }

@media screen and (min-width: 1050px){

.extra{
    grid-area:3 / 1 / 4 / 1
}
  }

@media screen and (min-width: 1050px){

.extra .right-side-wrapper{
      width:100%;
      display:flex;

      flex-direction:column;
      flex-wrap:wrap;
      justify-content:flex-end;
      align-items:flex-end
  }
    }

@media screen and (min-width: 1400px){

.extra .right-side-wrapper{
      justify-content:flex-end;
      align-items:center;
      flex-direction:row
  }
    }

.extra .card-wrapper{
    display:flex;
    flex-direction:column;
    padding:1rem 0px;
    gap:1rem;
  }

@media screen and (min-width: 1400px){

.extra .card-wrapper{
      flex-direction:row;
      max-width:100%
  }
    }

.prons{
  display:flex;
}

.divider{
  border-left:1px solid var(--brand-secondary-1);
  margin-inline:1ch;
}

.full-name{
  max-width:34ch;
}

.main-title,
.secondary-position{
  margin:0;
  font-family:var(--ff-dmsans);
}

.main-title{
  font-size:var(--fs-h3-mobile);
}

@media (min-width: 768px){

.main-title{
    font-size:var(--fs-h3)
}
  }

.secondary-position{
  font-size:var(--fs-h5--mobile);
}

@media (min-width: 768px){

.secondary-position{
    font-size:var(--fs-h5)
}
  }

.email{
  margin-top:1rem;
}

.email,
.phone{
  color:white;
  text-decoration:none;
  display:block;
}

.email:active,
.phone:active,
.email:hover,
.phone:hover{
  color:white;
  text-decoration:underline;
}

.social{
  display:flex;
  gap:1rem;
  padding:0;
  list-style:none;
  margin-top:1.5rem;
}

.offices-info{
  gap:1rem 2rem;
  display:flex;
  flex-direction:column;
  flex-wrap:wrap;
}

@media screen and (min-width: 640px){

.offices-info{
    flex-direction:row;
    align-items:center;
}
  }

.office-label{
  font-size:var(--fs-lg);
}

.office-label a,
.office-link a{
  text-decoration:none;
  color:var(--brand-primary-2);
}

.office-label a:hover,
.office-link a:hover{
  text-decoration:underline;
}

.office-link a{
  font-weight:var(--fw-bold);
}

.offices-info ul{
  padding:0;
  margin:0;
}

.offices-info li{
  list-style:none;
}

.download-vcard{
  margin-top:1.5rem;
}

.download-vcard,
.download-profile{
  font-size:var(--fs-xl);
}

.profile__download-link{
  display:flex;
  position:relative;
  align-items:center;
  gap:0.5rem;
  color:var(--gray-800);
  font-weight:var(--fw-bold);
  text-decoration:none;
  transition:200ms;
  margin:0.25rem 0;
  max-width:160px;
  width:100%;
  justify-content:space-between;
}

.profile__download-link::before{
  content:'';
  transition:200ms;
  position:absolute;
  width:0;
  height:3px;
  top:100%;
  left:0;
  margin-top:0.25rem;
  background-color:var(--brand-secondary-2);
}

.profile__download-link:hover::before{
  width:100%;
}

.profile__print-button{
  position:relative;
  width:-moz-fit-content;
  width:fit-content;
}

.profile__print-form{
  position:absolute;
  transition:500ms;
  overflow:hidden;
  margin-top:0.25rem;
  width:100%;
  z-index:3;
}

.profile__print-form.closed{
    height:0;
  }

.profile__print-form.open{
    height:300px;
  }

.profile__print-form ul{
    background-color:white;
    border-radius:12px;
    border:var(--brand-primary-2) solid 2px;
    list-style:none;
    padding:0.5rem;
    display:flex;
    flex-direction:column;
    gap:1.25rem;
    margin:0;
  }

.profile__print-form ul li{
      display:flex;
    }

.profile__print-form ul li p{
        margin:0;
        color:var(--gray-600);
        font-weight:var(--fw-normal);
      }

.profile__print-form input[type='checkbox']{
    color:var(--gray-600);
    height:44px;
    width:44px;
    appearance:none;
    -webkit-appearance:none;
    position:relative;
    border:3px solid #fff;
    box-shadow:0 0 0 1px var(--gray-600);
    cursor:pointer;
    aspect-ratio:1 / 1;
  }

@media (min-width: 768px){

.profile__print-form input[type='checkbox']{
      height:18px;
      width:18px
  }
    }

.profile__print-form input[type='checkbox']:checked{
      background:var(--brand-primary-2);
    }

.profile__print-form input[type='checkbox']:disabled{
      box-shadow:0 0 0 1px var(--gray-400);
      pointer-events:none;
      cursor:none;
    }

.profile__print-form input[type='checkbox']:disabled:checked{
        background:var(--gray-400);
      }

.profile__print-form input[type='checkbox']:focus:before{
        content:'';
        position:absolute;
        width:calc(100% + 12px);
        height:calc(100% + 12px);
        top:-6px;
        left:-6px;
        border:1px solid var(--brand-primary-1);
      }

.profile__print-form input[type='checkbox'] + label{
      color:var(--gray-800);
      font-family:var(--ff-dmsans);
      font-weight:var(--fw-bold);
      font-size:var(--fs-sm);
      padding-left:0.25rem;
      align-self:center;
    }

@media (min-width: 768px){

.profile__print-form input[type='checkbox'] + label{
        padding-left:0.75rem
    }
      }

.sr-only{
  position:absolute !important;
  overflow:hidden;
  clip:rect(1px, 1px, 1px, 1px);
  width:1px;
  height:1px;
  word-wrap:normal;
}
`;